import { render } from "./MiezzUpload.vue?vue&type=template&id=470a045b&scoped=true&ts=true"
import script from "./MiezzUpload.vue?vue&type=script&lang=ts"
export * from "./MiezzUpload.vue?vue&type=script&lang=ts"

import "./MiezzUpload.vue?vue&type=style&index=0&id=470a045b&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470a045b"]])

export default __exports__